export const ugovor_o_zajmu_izmedu_povezanih_nepovezanih_osoba = {
    templateId: 48,
    category: 5,
    templateTitle: "Ugovor o zajmu (novčanom) između povezanih/nepovezanih osoba",
    templateDescription: `<p>Ugovorom o zajmu obvezuje se zajmodavac predati zajmoprimcu određeni iznos/količinu zamjenljivih stvari (najčešće novca), a zajmoprimac se obvezuje vratiti mu poslije stanovitog vremena isti iznos novca, odnosno istu količinu stvari iste vrste i kakvoće.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovorom o zajmu obvezuje se zajmodavac predati zajmoprimcu određeni iznos novca ili određenu količinu drugih zamjenljivih stvari, a zajmoprimac se obvezuje vratiti mu poslije stanovitog vremena isti iznos novca, odnosno istu količinu stvari iste vrste i kakvoće.</p>
    <p>Zajam u načelu može biti beskamatan i uz kamate, no u ovom slučaju, poreznim su propisima utvrđeni posebni kriteriji kada poduzetnici, koji nisu banka ili druga financijska institucija, međusobno odobravaju ili primaju zajmove.</p>
    <p>Ovim tekstom te dolje navedenim primjerom uređuje se novčani zajam između povezanih odnosno nepovezanih osoba.</p>
    <p>Porezni tretman takvih zajmova prvenstveno ovisi o tome jesu li ugovorne strane rezidenti ili nerezidenti te radi li se o povezanim ili nepovezanim osobama.</p>
    <p>Rezidenti su pravne i fizičke osobe čije je sjedište upisano u sudski ili drugi registar ili upisnik u Republici Hrvatskoj ili kojima se mjesto stvarne uprave i nadzor poslovanja nalazi u Republici Hrvatskoj. Rezidenti su i poduzetnici fizičke osobe s prebivalištem ili uobičajenim boravištem u Republici Hrvatskoj čija je djelatnost upisana u registar ili upisnik.</p>
    <p>Nerezident je osoba koja ne ispunjava jedan iz gore navedenih uvjeta.</p>
    <p>Povezanim osobama smatraju se osobe kod kojih jedna osoba sudjeluje izravno ili neizravno u upravi, nadzoru ili kapitalu druge osobe, ili iste osobe sudjeluju izravno ili neizravno u upravi, nadzoru ili kapitalu društva.</p>
    <p>Pri tomu, u odnosu između povezanih/nepovezanih osoba odnosno rezidenata/nerezidenata moguće su sljedeće situacije u određivanju kamata:</p>
      <table class="table table-bordered">
      <tbody>
        <tr>
          <td>
          </td>
          <td>
          <p class="text-center"><strong>NEPOVEZANE OSOBE</strong></p>
          </td>
          <td>
          <p class="text-center"><strong>POVEZANE OSOBE</strong></p>
          </td>
        </tr>
        <tr>
          <td>
          <p class="text-center"><strong>REZIDENTI</strong></p>
          </td>
          <td>
            <p>Tržišna kamata</p>
          </td>
          <td>
            <p>Tržišna kamata ili, </p>
            <p>Propisana stopa - u slučaju da jedna od povezanih osoba ima povlašteni porezni status, odnosno plaća porez na dobit po stopama koje su niže od propisane stope ili je oslobođena od plaćanja poreza na dobit (npr. posluje na potpomognutim područjima), ili ima u poreznom razdoblju pravo na prijenos poreznog gubitka iz prethodnih poreznih razdoblja - odlukom ministarstva financija za 2022. godinu propisana stopa je 3,42%.</p>
            </td>
        </tr>
        <tr>
          <td>
          <p class="text-center"><strong>NEREZIDENTI</strong></p>
          </td>
          <td>
            <p>Tržišna kamata</p>
          </td>
          <td>
            <p>Za zajmove dane nerezidentima - <strong>najmanje stopa</strong> koju propisuje ministarstvo financija odlukom - za 2022. godinu iznosi od 3,42%.  </p>
            <p>Za zajmove primljene od nerezidenata - <strong>do najviše stope</strong> koju propisuje ministarstvo financija odlukom - za 2022. godinu iznosi od 3,42%.</p>
            </td>
        </tr>
      </tbody>
    </table>
    <br>
    <p><strong>Dakle, propisana stopa kamata (odlukom ministarstva financija) odnosi se na sljedeće dvije situacije između povezanih osoba, nerezidenata, te se porezno primjenuje na sljedeći način, ovisno o tome da li je zajam dan ili primljen:</strong></p>
    <p>- pri utvrđivanju <strong>prihoda od kamata na dane zajmove</strong> kod povezanih osoba - nerezidenata obračunava se kamata <strong>najmanje</strong> do visine kamatne stope koja bi se ostvarila između nepovezanih osoba u trenutku odobrenja zajma,</p>
    <p>- pri utvrđivanju <strong>rashoda od kamata na primljene zajmove</strong> kod povezanih osoba - nerezidenata, priznaju se obračunane kamate <strong>najviše</strong> do visine kamatne stope koja bi se ostvarila između nepovezanih osoba u trenutku odobrenja zajma.</p>
    <p><strong>Navedene propisane kamate se izuzetno obračunavaju i na zajmove povezanih osoba rezidenata, ako jedna od povezanih osoba ima povlašteni porezni status, odnosno plaća porez na dobit po stopama koje su niže od propisane stope ili je oslobođena od plaćanja poreza na dobit, ili ima u poreznom razdoblju pravo na prijenos poreznog gubitka iz prethodnih poreznih razdoblja.</strong></p>
    <p><strong>Tržišna (ugovorna) kamatna stopa može biti do sljedećih najviših stopa:</strong></p>
    <p>- stope zakonskih zateznih kamata između osoba od kojih barem jedna nije trgovac (trenutno 5,49% za prvo polugodište 2022. godine) koja je za te odnose vrijedila na dan sklapanja ugovora, odnosno na dan promjene ugovorne kamatne stope, ako je ugovorena promjenjiva kamatna stopa, uvećane za polovinu te stope - takva kamata je trenutno za prvo polugodište 2022. godine, 8,24%.</p>
    <p>- ugovornih kamata između trgovaca, odnosno trgovca i osoba javnog prava (osobe koje su dužne postupati po propisima o javnoj nabavi, osim trgovačkih društava) ne može biti viša od stope zakonskih zateznih kamata koja je za te odnose vrijedila na dan sklapanja ugovora (trenutno za prvo polugodište 2022. godine 7,49%), odnosno na dan promjene ugovorne kamatne stope, ako je ugovorena promjenjiva kamatna stopa, uvećane za tri četvrtine te stope - trenutno za prvo polugodište 2022. godine, 13,11%.</p>
    <p>Trgovac je osoba (pravna ili fizička) upisana u registar trgovačkog suda kao trgovačko društvo ili trgovac pojedinac.</p>
    <p>Važno je i napomenuti da su zatezne kamate (kamate koje se plaćaju za kašnjenje u ispunjenju obveze), između povezanih osoba za dužnika su porezno nepriznati rashod neovisno o tome je li ih zaračunalo tuzemno ili inozemno povezano društo i neovisno o tome po kojoj je stopi zatezna kamata obračunata.</p>
    <p>Na kamate (osim zateznih do visine zakonske zatezne kamate) koje s temelja danih zajmova međusobno zaračunavaju trgovačka društtva ili obrtnici, ne obračunava se PDV.</p>
    <p>Osim ugovorenih postoje i zatezne kamate (kamate koje se obračunavaju ukoliko dužnik ne ispuni obvezu u roku), koje se mogu ugovoriti posebno, a u slučaju da se ne ugovore (tada su to ugovorne zatezne kamate), primjenjuje se zakonska zatezna kamata.</p>
    <p>Na kamate i zatezne kamate ne obračunava se PDV.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima, Zakon o porezu na dobit, Pravilnik o porezu na dobit.</p>
  `,

    sides: [
        {
            signature: 'Zajmodavac:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Poslovni subjekt',
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    mandatory: false,
                    editable: true,
                    placeholder: "Zastupa (za pr. osobe)",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija (za pr. osobe)",
                    inSignature: true,
                }],
            suffix: ' (u daljnjem tekstu: Zajmodavac)',
            delimiter: `i`
        },
        {
            signature: 'Zajmoprimac:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Ime i prezime',
                inSignature: true,
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    mandatory: false,
                    editable: true,
                    placeholder: "Zastupa (za pr. osobe)",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija (za pr. osobe)",
                    inSignature: true
                }],
            suffix: ' (u daljnjem tekstu: Zajmoprimac),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR ZAJMU',
    noArticleNumbers: false,

    articles: [
        {
            title: 'ODNOS POVEZANOSTI',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ugovorne strane suglasno utvrđuju da se nalaze u odnosu povezanosti na način da se smatraju povezanim osobama sukladno Zakonu o porezu na dobit.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ugovorne strane suglasno utvrđuju da se ne nalaze u odnosu povezanosti na način da se smatraju povezanim osobama sukladno Zakonu o porezu na dobit.'
                                }]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'IZNOS ZAJMA',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Zajmodavac daje Zajmoprimcu zajam u iznosu od'},
                        {type: 'input', value: '', required: true,},
                        {
                            type: 'text',
                            content: ', a Zajmoprimac se obvezuje vratiti Zajmodavcu iznos zajma prema odredbama ovog Ugovora.'
                        }],
                }],
            value: '',
        },
        {
            title: 'UPLATA ZAJMA',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac će iznos Zajma uplatiti na žiro-račun Zajmoprimca, IBAN broj:'
                                },
                                {type: 'input', value: '', required: true,},
                                {
                                    type: 'text',
                                    content: ', otvoren kod'
                                },
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: 'd.d.,'},
                                {help: 'Upišite naziv banke u kojoj Zajmoprimac ima otvoren poslovni račun.'},
                                {type: 'text', content: 'odmah prilikom potpisa ovog Ugovora.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac će iznos Zajma uplatiti na žiro-račun Zajmoprimca, IBAN broj:'
                                },
                                {type: 'input', value: '', required: true,},
                                {
                                    type: 'text',
                                    content: ', otvoren kod'
                                },
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: 'd.d.,'},
                                {help: 'Upišite naziv banke u kojoj Zajmoprimac ima otvoren poslovni račun.'},
                                {type: 'text', content: 'u roku od'},
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: 'dana od dana potpisa ovog Ugovora.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac će iznos Zajma predati Zajmoprimcu u gotovini, u roku od'
                                },
                                {type: 'input', value: '', required: true,},
                                {
                                    type: 'text',
                                    content: 'dana od dana potpisa ovog Ugovora, a što će Zajmoprimac potvrditi svojim potpisom.',
                                    help: 'Prema Zakonu o sprječavanju pranja novca i financiranju terorizma, pravna ili fizička osoba koja obavlja registriranu djelatnost u Republici Hrvatskoj ne smije primiti naplatu ili obaviti plaćanje u gotovini u vrijednosti od 75.000,00 kuna na više. Navedena naplata ili plaćanje u gotovini, mora se provesti uplatom ili prijenosom na transakcijski račun.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac je iznos zajma predao Zajmoprimcu prilikom potpisa ovog Ugovora u gotovini, a što Zajmoprimac potvrđuje potpisom ovog Ugovora.',
                                    help: 'Prema Zakonu o sprječavanju pranja novca i financiranju terorizma, pravna ili fizička osoba koja obavlja registriranu djelatnost u Republici Hrvatskoj ne smije primiti naplatu ili obaviti plaćanje u gotovini u vrijednosti od 75.000,00 kuna na više. Navedena naplata ili plaćanje u gotovini, mora se provesti uplatom ili prijenosom na transakcijski račun.'
                                }]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'KAMATE',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Zajmodavac daje Zajmoprimcu zajam iz ovog Ugovora uz kamatnu stopu od'},
                        {type: 'input', value: '', required: true,},
                        {
                            type: 'text',
                            content: 'godišnje.',
                            help: 'Prije unosa kamatne stope molimo pažljivo pročitajte uvodni tekst gore.'
                        }],
                }],
            value: '',
        },
        {
            title: 'OBRAČUN KAMATA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Kamate se obračunavaju mjesečno, a obračun kamata dospijeva na naplatu do'
                                },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: '-og umjesecu za prethodni mjesec.',
                                    help: 'Ovaj članak je sastavni dio Ugovora isključivo ukoliko se zajam daje uz kamatu.'
                                },
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Kamate se obračunavaju pri povratu zajma, a obračun kamata dospijeva na naplatu povratom cjelokupnog iznosa zajma.',
                                    help: 'Ovaj članak je sastavni dio Ugovora isključivo ukoliko se zajam daje uz kamatu.'
                                }
                            ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'ROK VRAĆANJA ZAJMA',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Zajmoprimac se obvezuje Zajmodavcu vratiti zajam jednokratno, najkasnije do'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.'},
                            ]
                        },
                        {
                            parts: [
                              { type: "text", content: "Zajmoprimac se obvezuje Zajmodavcu vratiti zajam u sljedećim ratama i iznosima: " },
                              {type: "textarea", value: "", required: true },
                              { help: 'Ovdje samostalno i po vlastitoj volji upisujete iznose rata i rokove dospijeća svake pojedine rate.'}
                            ]
                          }
                        ],
                        value: "",
                      },
                    ]
                  },
        {
            title: 'RANIJI POVRAT ZAJMA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Zajmoprimac može zajam iz ovog Ugovora vratiti i prije roka određenog za vraćanje zajma. \r\nU slučaju prijevremenog vraćanja, Zajmoprimac je isti dužan najaviti 30 dana ranije.',
                        'Zajam iz ovog Ugovora nije moguće vratiti i prije roka određenog za vraćanje.'
                    ],
                    placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                }
            ]
        },
        {
            title: 'ZATEZNE KAMATE ',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ukoliko Zajmoprimac dospjele obveze iz ovog Ugovora ne podmiri u roku dospijeća, obvezan je na dospjele i nenaplaćene iznose platiti zateznu kamatu koja se obračunava u visini zakonske zatezne kamate.',
                                    help: 'Zakonske zatezne kamate primjenjive na ovaj Ugovor molimo provjerite u uvodnom tekstu ispred ovog predloška.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ukoliko Zajmoprimac dospjele obveze iz ovog Ugovora ne podmiri u roku dospijeća, obvezan je na dospjele i nenaplaćene iznose platiti zateznu kamatu koja se obračunava u visini'
                                },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: '% (ugovorna zatezna kamata).',
                                    help: 'Ova kamatu je moguće ugovoriti isključivo ukoliko je ugovornim stranama dopušteno tržišno određivati kamatu, a maksimalnu dopuštenu visinu iste molimo provjerite u tekstu ispred ovog predloška.',
                                }]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'SREDSTVA OSIGURANJA VRAĆANJA ZAJMA ',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmoprimac kao sredstvo osiguranja vraćanja zajma iz ovog Ugovora predaje Zajmodavcu bjanko zadužnicu na iznos do'
                                },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: 'kn, potvrđenu po javnom bilježniku, uz međusobni potpis zapisnika o primopredaji sredstava osiguranja.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmoprimac kao sredstvo osiguranja vraćanja zajma iz ovog Ugovora predaje Zajmodavcu običnu zadužnicu na iznos '
                                },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: 'kn, potvrđenu po javnom bilježniku, uz međusobni potpis zapisnika o primopredaji sredstava osiguranja.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmoprimac kao sredstvo osiguranja vraćanja zajma iz ovog Ugovora predaje Zajmodavcu vlastitu trasiranu mjenicu bez protesta, zajedno s pripadajućim mjeničimo očitovanjem, uz međusobni potpis zapisnika o primopredaji sredstava osiguranja.'
                                }
                            ]
                        },
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'RANIJE DOSPIJEĆE VRAĆANJA ZAJMA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Zajmodavac u svakom trenutku može učiniti zajam dospjelim pri čemu će Zajmoprimac biti dužan vratiti zajam u roku od'
                        },
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana od obavijesti Zajmodavca.'}],
                }],
        },
        {
            title: 'POVRAT ZAJMA ',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Po dospijeću obveza povrata glavnice, Zajmoprimac će novčana sredstva doznačiti na račun Zajmodavca otvoren u'
                                },
                                {type: 'input', value: '', required: true,}, 
                                {type: 'text', content: 'd.d.,', help: 'Upišite naziv banke u kojoj Zajmodavac ima otvoren poslovni račun.'},
                                {type: 'text', content:  'IBAN broj:'},
                                {type: 'input', value: '', required: true}
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Po dospijeću glavnice i kamata, Zajmoprimac će novčana sredstva doznačiti na račun Zajmodavca otvoren u'
                                },
                                {type: 'input', value: '', required: true,}, 
                                {type: 'text', content: 'd.d.,', help: 'Upišite naziv banke u kojoj Zajmodavac ima otvoren poslovni račun.'},
                                {type: 'text', content:  'IBAN broj:'},
                                {type: 'input', value: '', required: true}
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Po dospijeću obveza povrata glavnice, Zajmoprimac će novčana sredstva vratiti Zajmodavcu primopredajom u gotovini.',
                                    help: 'Prema Zakonu o sprječavanju pranja novca i financiranju terorizma, pravna ili fizička osoba koja obavlja registriranu djelatnost u Republici Hrvatskoj ne smije primiti naplatu ili obaviti plaćanje u gotovini u vrijednosti od 75.000,00 kuna na više. Navedena naplata ili plaćanje u gotovini, mora se provesti uplatom ili prijenosom na transakcijski račun.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Po dospijeću obveza povrata glavnice i kamate,  Zajmoprimac će novčana sredstva vratiti Zajmodavcu primopredajom u gotovini.',
                                    help: 'Prema Zakonu o sprječavanju pranja novca i financiranju terorizma, pravna ili fizička osoba koja obavlja registriranu djelatnost u Republici Hrvatskoj ne smije primiti naplatu ili obaviti plaćanje u gotovini u vrijednosti od 75.000,00 kuna na više. Navedena naplata ili plaćanje u gotovini, mora se provesti uplatom ili prijenosom na transakcijski račun.'
                                }
                            ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Zajmodavca.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Zajmoprimca.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                            ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/48_ugovor_o_zajmu_izmedu_povezanih_nepovezanih_osoba.ts